(function () {
  if (window.innerWidth > 767) return; 

  const style = document.createElement('style');
  style.textContent = `
    .svg-icon-row {
        display: flex;
        flex-direction: row;
        gap: 10px;
    }

    .svg-icon-row a.menu-lv-1__action.header__menu-item.list-menu__item.link.link--text.focus-inset.link-effect {
        display: flex;
        align-items: center;
        gap: 2px;
        padding: 10px 10px;
        justify-content: center;
        max-height: 40px;
    }

    .svg-icon-item {
      width: 50%;
      box-sizing: border-box;
    }

    .svg-icon-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    // .svg-visible-icon {
    //     width: 30px;
    //     height: 30px;
    // }

    li.menu-lv-item.menu-lv-1.text-left.no-megamenu {
        border: 1px solid #6E1D1C !important;
        border-radius: 2px;
        margin-bottom: 10px;
    }

    .menu-top-row {
        display: flex;
        gap: 10px;
    }

    .menu-top-row .menu-lv-item {
      flex: 1;
    }

    .menu-top-row .menu-lv-item a {
        justify-content: center;
        padding: 10px;
        border: none;
    }

    .halo-sidebar_menu .site-nav-mobile:not(.menu-custom-mobile) .list-menu .menu-lv-item {
        text-align: center;
        border: none;
    }

    .menu-icon {
        margin-right: 10px;
        flex-shrink: 0;
        max-width: 45px;
        height: 60px;
        width: auto;
        object-fit: contain;
        border-radius: 4px;
    }
    img.menu-icon[src*="/sale-discount"] {
      width: 45px;
      height: 45px;
    }

    li.menu-lv-item.menu-lv-1.text-left.no-megamenu.dropdown.is-open,
    li.menu-lv-item.menu-lv-2.text-left.navigation_all_mobile.d-none {
        text-align: left !important;
        background: unset !important;
    }

    ul.list-menu.list-menu--inline.text-center {
      padding: 0 15px;
      margin-top: 10px;
    }

    ul.header__submenu.list-menu.list-menu--disclosure.list-menu--disclosure-1.caption-large.motion-reduce {
        margin-left: -18px;
    }

    .menu-top-row .menu-lv-1__action {
        text-align: center;
    }
  `;
  document.head.appendChild(style);

  // const svgMap = {
  //   "Best Seller": `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" class="svg-visible-icon"><path fill="#6E1D1C" d="M240-400q0 52 21 98.5t60 81.5q-1-5-1-9v-9q0-32 12-60t35-51l113-111 113 111q23 23 35 51t12 60v9q0 4-1 9 39-35 60-81.5t21-98.5q0-50-18.5-94.5T648-574q-20 13-42 19.5t-45 6.5q-62 0-107.5-41T401-690q-39 33-69 68.5t-50.5 72Q261-513 250.5-475T240-400Zm240 52-57 56q-11 11-17 25t-6 29q0 32 23.5 55t56.5 23q33 0 56.5-23t23.5-55q0-16-6-29.5T537-292l-57-56Zm0-492v132q0 34 23.5 57t57.5 23q18 0 33.5-7.5T622-658l18-22q74 42 117 117t43 163q0 134-93 227T480-80q-134 0-227-93t-93-227q0-129 86.5-245T480-840Z"></path></svg>`,
  //   "New Arrivals": `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"  class="svg-visible-icon" fill="#6E1D1C"><path d="m280-80 160-300-320-40 480-460h80L520-580l320 40L360-80h-80Zm222-247 161-154-269-34 63-117-160 154 268 33-63 118Zm-22-153Z"></path></svg>`
  // };
  const svgMap = {
  "Best Seller": `<span class="svg-visible-icon" style="font-size: 24px; display: inline-block;">🔥</span>`,
  "New Arrivals": `<span class="svg-visible-icon" style="font-size: 24px; display: inline-block;">⚡</span>`
};


  const imgMap = {
    "Rakhi Collection": "https://mysanskritam.com/cdn/shop/files/86_539961b9-56a6-498e-967e-92278b41591f_200x.jpg?v=1751431552",
    "All Kurta": "https://mysanskritam.com/cdn/shop/files/9F95CE6A-3E52-41FC-A498-8D59896700B9_510x.jpg",
    "Kurta sets": "https://mysanskritam.com/cdn/shop/files/image00031-836835_l_510x.jpg",
    "Kurtas & Sets": "https://mysanskritam.com/cdn/shop/files/9F95CE6A-3E52-41FC-A498-8D59896700B9_510x.jpg",
    "Kurtas &amp; Sets": "https://mysanskritam.com/cdn/shop/files/9F95CE6A-3E52-41FC-A498-8D59896700B9_510x.jpg",
    "Kurtas amp; Sets": "https://mysanskritam.com/cdn/shop/files/9F95CE6A-3E52-41FC-A498-8D59896700B9_510x.jpg",
    "Co-ord sets": "https://cdn.shopify.com/s/files/1/0737/4677/6364/files/2_7f3537b2-927a-4f15-835c-d61effe409ce.webp?v=1750140412",
    "Bottom Wear": "https://mysanskritam.com/cdn/shop/files/2_4965657b-0360-45af-a10e-48889673b2c1_510x.png",
    "Indo western": "https://mysanskritam.com/cdn/shop/files/D3BBE10B-3789-4CC0-8E4C-04FAFA822322_510x.jpg",
    "Festive Bundle": "https://mysanskritam.com/cdn/shop/files/3220AEC4-636B-41B6-8793-0144239C9CF3_500x500.jpg?v=1739451967",
    "799 SALE": "https://cdn.shopify.com/s/files/1/0737/4677/6364/files/sale-discount_200x.png?v=1756385948",
    "Navratri Collection": "https://cdn.shopify.com/s/files/1/0737/4677/6364/files/navratri-menuimg_200x.jpg?v=1756825401",
    "Festive Collection": "https://mysanskritam.com/cdn/shop/files/86_539961b9-56a6-498e-967e-92278b41591f_200x.jpg?v=1751431552",
    "Winter Collection": "https://cdn.shopify.com/s/files/1/0737/4677/6364/files/7991B5ED-0FC5-4747-A892-A86805BE2F9B_2e84186a-c8f8-4b8f-be4e-1832bc8408dc_200x.jpg?v=1759816641",
    "Under 999": "https://cdn.shopify.com/s/files/1/0737/4677/6364/files/16190AA3-6361-450E-84A4-6C6F0A82D6AD_c96a3cd6-90f7-49e2-8183-9baebd470e97_200x.jpg?v=1759815830"
  };

  const ul = document.querySelector('.list-menu[role="list"]');
  if (!ul) return;

  const lis = [...ul.children];
  const reviewsLi = lis.find(li => li.textContent.includes("Reviews"));
  const exchangeLi = lis.find(li => li.textContent.includes("Exchange"));

  if (reviewsLi) ul.removeChild(reviewsLi);
  if (exchangeLi) ul.removeChild(exchangeLi);

  if (reviewsLi && exchangeLi) {
    const row = document.createElement('div');
    row.className = 'menu-top-row';
    row.appendChild(reviewsLi);
    row.appendChild(exchangeLi);
    ul.appendChild(row);
  }

  const iconRow = document.createElement('div');
  iconRow.className = 'svg-icon-row';

  lis.forEach(li => {
    const span = li.querySelector('span.text');
    if (!span) return;
    /*const text = span.textContent.trim();
    */
    let text = span.textContent.trim();
    // Fix HTML entity issues
    text = text.replace(/&amp;\s/g, "&");
    text = text.replace(/&\s/g, "");
    // Normalize multiple spaces
    text = text.replace(/\s+/g, " ").trim();
    
    // Fix capitalization mismatch (convert to Title Case)
    //text = text.replace(/\w\S*/g, w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());

    console.log("ACTUAL TEXT IS - " + text);


    if (svgMap[text]) {
      const anchor = li.querySelector('a');
      if (anchor) {
        const wrapper = document.createElement('div');
        wrapper.className = 'svg-icon-wrapper';
        wrapper.innerHTML = svgMap[text];
        anchor.prepend(wrapper);
      }

      li.classList.add('svg-icon-item');
      ul.removeChild(li);
      iconRow.appendChild(li);

    //console.log("ACTUAL TEXT IS - " text);

    } else {
      const imgSrc = imgMap[text];
      if (!imgSrc || li.querySelector('img')) return;

      const img = document.createElement('img');
      img.src = imgSrc;
      img.alt = text;
      img.className = 'menu-icon';

      const anchor = li.querySelector('a');
      if (anchor) {
        anchor.style.display = 'flex';
        anchor.style.alignItems = 'center';
        anchor.insertBefore(img, span);
      }

    //console.log("ACTUAL TEXT IS - " text);
    
    }
  });

  if (iconRow.children.length) {
    ul.prepend(iconRow);
  }

  const menuTitle = document.querySelector('.menu-heading-mobile .title');
  if (menuTitle) {
    menuTitle.innerHTML = `<img src="https://mysanskritam.com/cdn/shop/files/sanskritilogofnall-789774_header_logo_200x.png" alt="Sanskriti Logo" style="height: 32px; max-width: 100%;">`;
  }
})();
